import useSortOrder from 'Utilities/hooks/vehicleList/useSortOrder/useSortOrder';
import { FOR_SALE_CATEGORY } from 'Utilities/vehicleState';

import { OPTIMIZELY_EVENTS } from '../optimizely.consts';

import { useTrackEventWhenReady } from './useTrackEventWhenReady';

type UseTriggerBidPlacedEvent = (stateSlug: string) => void;

export const useTriggerBidPlacedEvent = (): UseTriggerBidPlacedEvent => {
	const track = useTrackEventWhenReady(OPTIMIZELY_EVENTS.BID_PLACED);
	const { sort } = useSortOrder();

	return (stateSlug) => {
		const isSaleActiveVehicle = stateSlug === FOR_SALE_CATEGORY.SALE_ACTIVE;
		const isRecommendedSortOrderActive = sort === 'recommended';

		track({
			attributes: {
				isLiveSale: isSaleActiveVehicle,
				isRecommendedSortOrderActive,
			},
		});
	};
};
